import React, { useEffect, useState } from "react";
import BlogPost from "crm/other/BlogPost";
import IndustryDetailTemplate from "pages/industries/IndustryDetailTemplate";
import { getBlogsBySlug } from "helpers/api/BlogService";
import { Navigate } from "react-router-dom";
import { useParams, useLocation } from "react-router-dom";

export default function DynamicPage() {
    const { slug } = useParams<{ slug: string }>();
    const location = useLocation();
    const menuRoutes = [
        "features",
        "about",
        "contact",
        "blogs",
        "industries",
        "privacy",
        "termsAndConditions",
        "home"
    ];
    const stateData = location.state as {
        type?: "blog" | "industry";
        data?: any;
    };

    const [type, setType] = useState<"blog" | "industry" | "notfound">("blog");
    const [data, setData] = useState<any>(null);

    // useEffect(() => {

    //     if (stateData?.type && stateData?.data) {
    //         setType(stateData.type);
    //         setData(stateData.data);
    //         return;
    //     }
    //     if (!slug) return;

    //     getBlogsBySlug(slug)
    //         .then((res) => {
    //             if (res?.success && res.result) {
    //                 if (res.result.isBlog === false) {
    //                     setType("industry");
    //                 } else {
    //                     setType("blog");
    //                 }

    //                 setData(res.result);
    //             } else {
    //                 setType("notfound");
    //             }
    //         })
    //         .catch(() => setType("notfound"));
    // }, [slug, stateData]);


    useEffect(() => {
        if (!slug) return;

        const menuRoutes = [
            'features',
            'industries',
            'about',
            'contact',
            'blogs',
            'privacy',
            'termsAndConditions'
        ];

        if (menuRoutes.includes(slug)) {
            setType("notfound");
            return;
        }

        // ✅ state navigation
        if (stateData?.type && stateData?.data) {
            setType(stateData.type);
            setData(stateData.data);
            return;
        }

        // ✅ API call
        getBlogsBySlug(slug)
            .then((res) => {
                if (res?.success && res.result) {
                    if (res.result.isBlog === false) {
                        setType("industry");
                    } else {
                        setType("blog");
                    }
                    setData(res.result);
                } else {
                    setType("notfound");
                }
            })
            .catch(() => setType("notfound"));
    }, [slug, stateData]);

    if (type === "notfound") return <Navigate to="/" replace />;

    if (type === "industry") {
        return <IndustryDetailTemplate blogData={data} />;
    }

    return <BlogPost blogData={data} />;
}

